module.exports = __webpack_public_path__ + "img/bar-2.86980f84.svg";